import React from "react";

export const mergeContexts = (contexts: React.FC<React.PropsWithChildren>[]) => {
    return contexts.reduce<React.FC<React.PropsWithChildren>>((Acc,Cur) => {
        return (props) => <Cur><Acc>{props.children}</Acc></Cur>
    }, (props) => <>{props.children}</>)
}
